import { formatedDay, formatedMonth, formatedYear } from '../alpine-functions';

import { BOTH_TYPE, CZK, IN_PERSON_TYPE, FREE } from '../misc/consts';

export default () => ({
  closestEvents: [],
  selectedEvent: null,

  formatedPlace(event) {
    if (event.event_type === BOTH_TYPE) {
      return `${event.city}, prezenčně nebo online`;
    } else if (event.event_type === IN_PERSON_TYPE) {
      return `${event.city}`;
    } else {
      return 'Online';
    }
  },

  date(event) {
    return `${formatedDay(event.start)} ${formatedMonth(
      event.start
    )} ${formatedYear(event.start)} ${this.formatedDays(event)}`;
  },

  formatedDays(event) {
    if (event.duration < 1) {
      return '(½ dne)';
    } else if (event.duration === 1) {
      return '(1 den)';
    } else if (event.duration < 5) {
      return `(${event.duration} dny)`;
    } else {
      return `(${event.duration} dnů)`;
    }
  },

  formatedMoney(czk) {
    if (parseInt(czk) === 0) {
      return FREE;
    }
    return `${parseInt(czk.slice(0, -3)).toLocaleString(this.locale)} ${CZK}`;
  },

  getClosestEvents() {
    let events = [...this.$store.events.get()];
    return events.slice(0, 2);
  },

  tcDays(duration, customDuration) {
    return tcDays(duration, customDuration);
  },
});
